<p-dialog
  [header]="titleKey() | transloco"
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [modal]="true"
  [style]="{width: 'min(900px, 95vw)', height: '600px'}"
  [breakpoints]="{'960px': '95vw', '640px': '95vw'}"
  [draggable]="false"
  [resizable]="false"
  (onHide)="close()"
>
  <div class="flex flex-col chat-container">
    <!-- Chat messages area -->
    <div class="overflow-y-auto mb-4 chat-messages" #messagesContainer>
      @if (comments().length === 0) {
        <div class="text-center text-gray-400 py-8">
          {{ noCommentsKey() | transloco }}
        </div>
      }

      @for (comment of comments(); track comment) {
        <div class="mb-4">
          <div
            class="flex flex-col"
            [ngClass]="{
              'items-end': comment.userId === currentUserId(),
              'items-start': comment.userId !== currentUserId(),
            }"
          >
            <!-- User name and timestamp -->
            <div class="flex items-baseline gap-2 mb-1 px-1">
              <span
                class="font-semibold text-sm"
                [ngClass]="{
                  'text-blue-400': comment.userId === currentUserId(),
                  'text-gray-400': comment.userId !== currentUserId(),
                }"
              >
                {{
                  comment.user
                    ? comment.user.firstName + ' ' + comment.user.lastName
                    : 'Unknown User'
                }}
              </span>
              <span class="text-xs text-gray-500">
                {{ formatDateTime(comment.createdAt) }}
              </span>
            </div>

            <!-- Comment bubble -->
            <div
              class="rounded-lg px-4 py-2 max-w-[75%] wrap-break-word shadow-xs"
              [ngClass]="{
                'bg-blue-500 text-white': comment.userId === currentUserId(),
                'bg-gray-200 text-gray-800': comment.userId !== currentUserId(),
              }"
            >
              <p class="whitespace-pre-wrap text-sm">{{ comment.comment }}</p>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- New comment input area -->
    @if (!readOnly()) {
      <div class="pt-4 shrink-0">
        <div class="flex gap-2 items-center">
          <textarea
            pTextarea
            [(ngModel)]="newComment"
            [rows]="2"
            [autoResize]="true"
            class="flex-1 comment-input"
            [placeholder]="placeholderKey() | transloco"
            (keydown.enter)="onEnterKey($any($event))"
          ></textarea>
          <button
            pButton
            icon="pi pi-send"
            [disabled]="!newComment.trim()"
            (click)="sendComment()"
            class="p-button-rounded p-button-icon-only"
            [pTooltip]="sendLabelKey() | transloco"
            [attr.aria-label]="sendLabelKey() | transloco"
          ></button>
        </div>
      </div>
    }
  </div>
</p-dialog>
